module.exports = __webpack_public_path__ + "static/media/animated_ashish.0dea5f65.png";